module.exports = __webpack_public_path__ + "static/media/M1-R1-Recurso-codR4.63b0a0e8.png";